import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { useAdmin } from "../../context/AdminContext.js";
import "./Admin.css";

const AdminLayout = () => {
  const { admin, logout } = useAdmin();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className="admin-shell">
      <header className="admin-header">
        <div className="admin-brand">Aeti Admin</div>

        <button
          type="button"
          className="admin-burger-icon"
          onClick={() => setIsMenuOpen((open) => !open)}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className={`admin-mobile-menu ${isMenuOpen ? "admin-mobile-menu-open" : ""}`}>
          <nav className="admin-nav">
            <NavLink to="/admin/dashboard" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>Dashboard</NavLink>
            <NavLink to="/admin/quote-leads" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Quote Leads
            </NavLink>
            <NavLink to="/admin/contact-messages" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Contact Messages
            </NavLink>
            <NavLink to="/admin/bookings" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Bookings
            </NavLink>
            {admin?.role === "super_admin" && (
              <NavLink to="/admin/admins" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
                Admins
              </NavLink>
            )}
            <NavLink to="/admin/security" onClick={closeMenu} className={({ isActive }) => (isActive ? "active" : "")}>
              Security
            </NavLink>
          </nav>
          <div className="admin-account">
            <span>
              {admin?.name} <em>({admin?.role})</em>
            </span>
            <button type="button" onClick={handleLogout}>
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
